import { render } from "./StockProductStatusFilter.vue?vue&type=template&id=8e84d52c&scoped=true"
import script from "./StockProductStatusFilter.vue?vue&type=script&lang=js"
export * from "./StockProductStatusFilter.vue?vue&type=script&lang=js"

import "./StockProductStatusFilter.vue?vue&type=style&index=0&id=8e84d52c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e84d52c"]])

export default __exports__